module.exports = __webpack_public_path__ + "static/media/LK_White_Location Pin.f686bba5.svg";